/// <reference path="../_references.ts"/>

module App.Helpers {
	import AddressComponent = App.Customer.AddressComponent;
	import AddressComponents = App.Customer.AddressComponents;
	import Autocomplete = google.maps.places.Autocomplete;
	import PlaceResult = google.maps.places.PlaceResult;

	interface Scope extends ng.IScope {
		gPlace: Autocomplete;
		fields: {
			street: string;
			city: string;
			state: string;
			zip: string;
			latitude: number;
			longitude: number;
		}
	}

	export class GooglePlaceDirective {
		public link: (scope: ng.IScope, element: ng.IAugmentedJQuery) => void;
		public scope = {
				ngModel: '=',
				details: '=?',
				fields: '='
			};
		public require: string = 'ngModel';

		constructor() {

			GooglePlaceDirective.prototype.link = (scope: Scope, element: ng.IAugmentedJQuery) => {
				let options = {
					types: ['geocode']
				}, 
				ele = <HTMLInputElement>(<any>(element))[0];

				scope.gPlace = new google.maps.places.Autocomplete(ele, options);

				google.maps.event.addListener(scope.gPlace, 'place_changed', function() {
					let addressComponents: AddressComponents,
						geoComponents = scope.gPlace.getPlace();

						addressComponents = new AddressComponents();

						addressComponents.streetNum = getAddressComponent(geoComponents, 'street_number', 'long');
						addressComponents.streetName = getAddressComponent(geoComponents, 'route', 'long');
						addressComponents.city = getAddressComponent(geoComponents, 'locality', 'long');
						addressComponents.postalCode = getAddressComponent(geoComponents, 'postal_code', 'long');
						addressComponents.state = getAddressComponent(geoComponents, 'administrative_area_level_1', 'short');
						addressComponents.latitude = geoComponents.geometry.location.lat();
						addressComponents.longitude = geoComponents.geometry.location.lng();

					function getAddressComponent(address: PlaceResult, component: string, type: string): string {
						var elements = null;

						angular.forEach(address.address_components, function(addressComponent: AddressComponent) {
							if(addressComponent.types[0] === component) {
								elements = type === 'short' ? addressComponent.short_name : addressComponent.long_name;
							}
						});

						return elements;
					}

					scope.fields.street = '';
					scope.fields.city = addressComponents.city;
					scope.fields.state = addressComponents.state;
					scope.fields.zip = addressComponents.postalCode;
					scope.fields.latitude = addressComponents.latitude;
					scope.fields.longitude = addressComponents.longitude;
					scope.$apply();

					scope.fields.street = (addressComponents.streetNum ? addressComponents.streetNum + ' ' : '') + addressComponents.streetName;
					scope.$apply();
				});

			}

		}

		public static Factory() {
            let instance = () => {
                return new GooglePlaceDirective();
            };

            return instance;
        }


	}

	angular.module('helpers.googlePlace', [])
        .directive('googleplace', GooglePlaceDirective.Factory());

}